import { I18nextProvider } from "react-i18next";
import { i18n } from "@tellescope/i18n";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Router } from "./routing/Router";
import { InteractiveWindowProvider } from "@tellescope/ui";
import { GOOGLE_CLIENT_ID } from "./constants/google-auth";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <I18nextProvider i18n={i18n}>
          <InteractiveWindowProvider>
            <Router />
          </InteractiveWindowProvider>
        </I18nextProvider>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
